var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#0DBFE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5574 9.93381L15.5829 15.9083C13.0829 18.4146 11.1897 21.4598 10.0484 24.8107C9.99392 24.9692 9.98525 25.1398 10.0233 25.303C10.0614 25.4662 10.1447 25.6153 10.2637 25.7334L10.2668 25.7365C10.3496 25.8199 10.4481 25.8861 10.5565 25.9314C10.665 25.9766 10.7814 25.9999 10.8989 26C10.9978 25.9999 11.096 25.9836 11.1896 25.9518C14.5405 24.8104 17.5857 22.9171 20.0919 20.4171L26.0662 14.4427C26.6641 13.8448 27 13.0338 27 12.1883C27 11.3427 26.6641 10.5317 26.0662 9.93382C25.7702 9.63777 25.4187 9.40292 25.0319 9.2427C24.6451 9.08247 24.2305 9 23.8118 9C22.9662 9 22.1553 9.3359 21.5574 9.93381ZM19.2797 19.605C17.0215 21.8573 14.3017 23.5929 11.3079 24.6922C12.4072 21.6984 14.1428 18.9786 16.395 16.7204L19.954 13.1614L22.8386 16.046L19.2797 19.605ZM25.2541 13.6306L23.6507 15.2339L20.7661 12.3493L22.3695 10.7459C22.5588 10.5561 22.7837 10.4054 23.0313 10.3025C23.2789 10.1996 23.5443 10.1466 23.8124 10.1464C24.0805 10.1462 24.346 10.1989 24.5938 10.3014C24.8415 10.4039 25.0666 10.5542 25.2562 10.7438C25.4458 10.9334 25.5961 11.1585 25.6986 11.4063C25.8012 11.654 25.8538 11.9195 25.8536 12.1876C25.8534 12.4558 25.8004 12.7212 25.6975 12.9688C25.5946 13.2164 25.4439 13.4413 25.2541 13.6306Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2108f8d4b17faece9221dfcee45ea85c.svg";
export { ForwardRef as ReactComponent };